
/* injects from baggage-loader */

'use strict';

export default class HeaderController {
    constructor($log, $rootScope, $q, $timeout, User, Parse) {
        'ngInject';

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.UserService = User;
        this.Parse = Parse;
        this.$q = $q;
        this.$timeout = $timeout;

        this.user = {};
        this.showMobileMenu = false;
        this.showAccountDropdown = false;
        this.showSearchField = false;

        this.adminLinks = [];

        // Links shown on the header
        this.links = [
            {
                title: 'Projects',
                state: 'projects'
            },
            {
                title: 'About',
                state: 'about'
            },
            // {
            //     title: 'Raise Funds',
            //     state: 'raise-funds'
            // },
            {
                title: 'Blog',
                href: 'https://blog.commonowner.com'
            }
        ];

        // Account dropdown links
        this.account_links = [
            {
                title: 'My Account',
                state: 'account.home'
            },
            {
                title: 'Logout',
                state: 'accountLogout'
            }
        ]

    }

    $onInit() {

        // Current user account
        this.user = this.UserService.getCurrent();

        // Refresh user object on each refresh
        // if (this.user) {
        //     this.user.fetch();
        // }

        // Load user roles
        if (this.user) {
            this.UserService.fetchRoles();
        }

        // Listen for updates to the user profile
		this.$rootScope.$on('userProfileUpdated', event => {
            this.user.fetch();
		});

    }

    /**
     * Return the current user else returns false
     */
    userLoggedIn() {
        return this.UserService.isUserLoggedIn();
    }

    toggleAccountDropdown() {
        this.showAccountDropdown = !this.showAccountDropdown;
    }

    toggleMobileMenu() {
        this.showMobileMenu = !this.showMobileMenu;
    }

    toggleSearchField() {
        this.showSearchField = !this.showSearchField;
    }

    getUserFullName() {
        return this.user.get('full_name').split(' ')[0];
    }

    // async getAdminOptions() {
    //     let d = this.$q.defer();

    //     let options = [
    //         {
    //             title: 'Enter Admin Mode',
    //             state: 'admin.home',
    //             visible: this.UserService.hasRole('Admins')
    //         }
    //     ];
    //     this.$log.log(JSON.stringify(options))
    //     d.resolve(options);

    //     return d.promise;
    // }

    getAdminOptions() {
        let options = [
            {
                title: 'Enter Admin Mode',
                state: 'admin.home',
                visible: this.UserService.hasRole('Admins')
            }
        ]
        this.$log.log(JSON.stringify(options))
        return options;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/header/header.controller.js